import { render, staticRenderFns } from "./HospitalAdmins.vue?vue&type=template&id=481340e8&"
import script from "./HospitalAdmins.vue?vue&type=script&lang=js&"
export * from "./HospitalAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports